/**
 * TanStack Query hooks for `invoice-dispute-workflow`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	invoiceDisputeWorkflowQueryKeys,
	type CreateInvoiceDisputeWorkflowBody,
	type ListInvoiceDisputeWorkflowResponse,
	type InvoiceDisputeWorkflowRow,
} from "./api";

export function useInvoiceDisputeWorkflowList(): UseQueryResult<ListInvoiceDisputeWorkflowResponse, Error> {
	return useQuery({
		queryKey: invoiceDisputeWorkflowQueryKeys.list(),
		queryFn: list,
	});
}

export function useInvoiceDisputeWorkflowCreate(): UseMutationResult<InvoiceDisputeWorkflowRow, Error, CreateInvoiceDisputeWorkflowBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invoiceDisputeWorkflowQueryKeys.all });
		},
	});
}

export function useInvoiceDisputeWorkflowDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invoiceDisputeWorkflowQueryKeys.all });
		},
	});
}
